import moment from 'moment';
import { Divider } from '@mantine/core';

import { humanizeText } from 'utils/utility';
import { IHotelOnlineBookingList } from 'libs/data-access/types';
import { EBadge } from 'libs/ui';

interface IProps {
    type: "CHECK-IN" | "CHECK-OUT";
    date: string;
};

const CheckDate = ({ type, date }: IProps) => {
    return (
        <div>
            <p className='text-slate-400 opacity-95'>{type}</p>
            <div className='flex gap-2 items-center' >
                <p className='text-5xl font-bold'>{moment(date).format("DD")}</p>
                <div>
                    <div className='text-slate-500 text-sm'>{moment(date).format("MMM YYYY")}</div>
                    <div className='text-slate-900 text-sm font-semibold opacity-80'>{moment(date).format("ddd hh:mm A")}</div>
                </div>
            </div>
        </div>
    );
};

const HotelDetails = ({ hotel }: { hotel: IHotelOnlineBookingList }) => {
    return (

        <div>
            <div className="flex justify-between items-center">
                <div>
                    <p className='text-2xl font-semibold'>{hotel?.paymentOrderResponse?.hotel?.name}</p>
                    <p className='text-slate-500 text-sm'>{hotel?.paymentOrderResponse?.hotel?.address}</p>
                    <p className='font-normal opacity-95 text-sm' ><span className=' text-slate-500'>Contact No. </span> {" " + hotel?.paymentOrderResponse?.hotel?.phones?.map(phone => phone.phoneNumber)?.join(', ')}</p>
                    <p className='text-slate-500 text-sm lowercase'><span className='capitalize' >Email: </span>{hotel?.paymentOrderResponse?.hotel?.email}</p>
                    <p className='text-base'>Ref No: {hotel?.referenceNo ? `${hotel.referenceNo}` : ""}</p>
                </div>
                <EBadge>{humanizeText(hotel?.bookingStatus)}</EBadge>
            </div>

            <Divider className='my-4 w-full' />

            <div className='flex justify-between gap-4 pr-10'>
                <CheckDate
                    type='CHECK-IN'
                    date={hotel?.paymentOrderResponse?.hotelOrderDetail?.checkIn}
                />
                <div className='flex items-center justify-center relative'>
                    <div className='border h-full rotate-45'></div>
                    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full px-3 p-0.5 bg-slate-200 whitespace-nowrap text-sm '>
                        {
                            moment(hotel?.paymentOrderResponse?.hotelOrderDetail?.checkOut).diff(moment(hotel?.paymentOrderResponse?.hotelOrderDetail?.checkIn), 'days')
                        } NIGHT STAY
                    </div>
                </div>
                <CheckDate
                    type='CHECK-OUT'
                    date={hotel?.paymentOrderResponse?.hotelOrderDetail?.checkOut}
                />
            </div>

            {/* <div>
                <div className='h-44 rounded-lg overflow-hidden'>
                    <Image src={"https://lh3.googleusercontent.com/p/AF1QipNRwx1TUMOEMQHWQlv6GBol-zuJ9v_JlZ6A4Ag=w287-h192-n-k-rw-no-v1"} className='h-44 overflow-hidden border rounded' />
                </div>
                <div className='mt-2 h-14 rounded-lg rounded-t-none overflow-hidden cursor-pointer brightness-75 flex items-center justify-center bg-slate-200'
                    onClick={() => window.open("https://maps.google.com/", "_blank")}
                >
                    Location <MdLocationPin />
                </div>
            </div> */}
        </div>
    );
}

export default HotelDetails;
